import React from 'react';
import { hotelData } from '../data/hotelData';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';

const Testimonials = () => {
  return (
    <section className="py-24 bg-luxury-beige/20 overflow-hidden relative">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-[0.03] pointer-events-none">
        <Quote className="absolute top-10 left-10 w-32 h-32 text-orange-500" />
        <Quote className="absolute bottom-10 right-10 w-32 h-32 text-orange-500 rotate-180" />
      </div>

      <div className="container-custom relative z-10">
        <div className="text-center mb-20">
          <motion.span 
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-orange-500 text-[10px] tracking-[0.5em] uppercase font-black mb-4 block"
          >
            Guest Experiences
          </motion.span>
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-4xl md:text-5xl font-serif text-luxury-black leading-tight"
          >
            What Our Visitors Say
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {hotelData.testimonials.map((test, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-12 rounded-[2rem] shadow-[0_15px_40px_rgba(0,0,0,0.03)] flex flex-col items-center text-center group hover:shadow-[0_30px_60px_rgba(249,115,22,0.1)] transition-all duration-700"
            >
              <div className="flex gap-1.5 mb-8">
                {[...Array(test.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-orange-400 text-orange-400" />
                ))}
              </div>
              
              <p className="text-gray-500 font-light tracking-wide leading-[1.8] mb-10 text-lg">
                "{test.feedback}"
              </p>
              
              <div className="mt-auto pt-8 border-t border-gray-50 w-full">
                <h4 className="text-xl font-serif text-luxury-black mb-1">{test.name}</h4>
                <span className="text-[9px] text-orange-500 font-black uppercase tracking-[0.3em]">Verified Guest</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
